module.exports = "<dl class=modal-body> <dt class=list-item ng-repeat-start=\"type in availableAttrTypes\"> <a ng-click=createNewAttribute(type) data-modal=edit-field> {{type.label}} </a> </dt> <dd ng-repeat-end=\"\">{{type.description}}</dd> </dl> ";


//////////////////
// WEBPACK FOOTER
// ./app/settings/surveys/attribute-create.html
// module id = 838
// module chunks = 0